import { createStore as originalCreateStore } from 'redux';
import { accountReducer } from './reducers';
import memes from '../../memes';
export const createAccountStore = memes((initialState) => {
    return originalCreateStore(accountReducer, initialState);
});
export * from './communications';
